import * as React from 'react';
import { Loader, Container, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    container: {
        paddingTop: theme.spacing.xl,
        paddingBottom: theme.spacing.xl,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        flex: 1,
        flexGrow: 1
    }
}));

export const Spinner: React.FC = () => {
    const { classes } = useStyles();

    return (
        <Container className={classes.container}>
            <Loader />
        </Container>
    );
};
